import api from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

export interface IUpdatePatientInfo {
  cpf?: string
  dateBirth?: string
  gender?: string
}

export const updatePatientInfo = async ({
  cpf,
  dateBirth,
  gender
}: IUpdatePatientInfo): Promise<string> => {
  try {
    const payload = {
      ...(cpf && { cpf: cpf }),
      ...(dateBirth && { date_birth: dateBirth }),
      ...(gender && { gender: gender }),
    }

    const response = await api.patch(apiEndpoints.ME, payload)

    return response.status.toString()

  } catch(error) {
    let message = ''
    if (error instanceof Error) {
      message = error?.message
    } else {
      message = String(error)
    } 
    
    return Promise.reject(message)
  }
}